import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import app from '../config/firebase';

const storage = getStorage(app);

export const uploadFile = (file, onProgress, onComplete, onError, fileId = null) => {
  if (!file) return;

  // Create a reference to the storage location with fileId if provided
  const fileName = fileId ? `${fileId}_${file.name}` : `${Date.now()}_${file.name}`;
  const storageRef = ref(storage, `uploads/${fileName}`);
  
  // Start the upload process
  const uploadTask = uploadBytesResumable(storageRef, file);

  // Listen for state changes, errors, and completion of the upload
  uploadTask.on(
    'state_changed',
    (snapshot) => {
      // Get upload progress
      const progress = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      if (onProgress) onProgress(progress);
    },
    (error) => {
      // Handle errors
      console.error('Upload error:', error);
      if (onError) onError(error.message);
    },
    async () => {
      // Upload completed successfully, get download URL
      try {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        if (onComplete) onComplete(downloadURL);
      } catch (error) {
        console.error('Error getting download URL:', error);
        if (onError) onError('Failed to get download URL');
      }
    }
  );

  // Return the upload task so it can be cancelled if needed
  return uploadTask;
}; 